// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1EQlS","header":"ReportDetails_header__36A1v","title":"ReportDetails_title__RaGOP","left":"ReportDetails_left__3yQ61"};